import isHotkey from 'is-hotkey';
import { useCallback } from 'react';
import { useOpenPage } from 'src/hooks/page/use-open-page';
import { useGetPageId, useSwitchLeftRight } from 'src/utils/getPageId';
import { parseRightPageId, rightPage, useCloseRight, useOpenRight } from 'src/utils/right-utils';

export const useRightPageKey = () => {
  const closeRight = useCloseRight();
  const openRight = useOpenRight();
  const switchLeftRight = useSwitchLeftRight();
  const openPage = useOpenPage();
  const pageId = useGetPageId();

  const rightPageKey = (event: KeyboardEvent) => {
    const rightPageId = parseRightPageId(location.search);

    if (isHotkey('Alt+Q')(event)) {
      if (rightPageId) {
        event.preventDefault();
        closeRight();
        return;
      }
      openPage(rightPage.lastPageId || pageId, {
        forceOpenInRight: true,
        onOpenInRight: () => {
          event.preventDefault();
        },
        forceOpenNewTab: event.ctrlKey || event.metaKey,
      });
    }

    if (isHotkey('Alt+F')(event)) {
      if (rightPageId) {
        event.preventDefault();
        openRight();
      }
    }

    if (isHotkey("Alt+'")(event)) {
      if (rightPageId) {
        event.preventDefault();
        switchLeftRight();
      }
    }
  };

  return useCallback(rightPageKey, [closeRight, openPage, openRight, pageId, switchLeftRight]);
};
